<template>
    <div>
        <h5>Filters:</h5>
        <div class="row">
            <div class="col-xs-12">
                <datepicker v-model="options.startDate" :calendar-button="true" calendar-button-icon="fa fa-calendar"
                            :clear-button="true" clear-button-icon="fa fa-times" :bootstrap-styling="true"
                            format="yyyy MMM dd" @input="changed" :typeable="isTypeable"></datepicker>
            </div>
            <div class="col-xs-12 text-center date-to">
                to
            </div>
            <div class="col-xs-12">
                <datepicker v-model="options.endDate" :calendar-button="true" calendar-button-icon="fa fa-calendar"
                            :clear-button="true" clear-button-icon="fa fa-times" :bootstrap-styling="true"
                            format="yyyy MMM dd" @input="changed" :typeable="isTypeable"></datepicker>
            </div>
            <div class="col-xs-12">
                <div class="row reverese-clerical-toggles">
                    <div class="col-xs-12">
                        <label>
                            <input type="checkbox" v-model="options.showReversed" @change="changed" />
                            Show reversed
                        </label>
                    </div>
                    <div class="col-xs-12">
                        <label>
                            <input type="checkbox" v-model="options.showClerical" @change="changed" />
                            Show clerical
                        </label>
                    </div>
                </div>
            </div>
        </div>

        <h5>Sorting:</h5>

        <div class="row filter-functions-sort-mobile">
            <div class="col-xs-12">
                <div class="input-group no-borders">
                    <label class="input-group-addon">Results at a time:</label>
                    <select class="form-control" v-model="options.pageSize" @change="changed">
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="10000">All</option>
                    </select>
                </div>
            </div>

            <div class="col-xs-12 sort-by">
                <div class="input-group no-borders">
                    <label class="input-group-addon">Sort by:</label>
                    <select class="form-control" v-model="options.sortDirection" @change="changed">
                        <option value="DESC">Recent first</option>
                        <option value="ASC">Oldest first</option>
                    </select>
                </div>
            </div>

            <div class="col-xs-12 expand-notes">
                <label>
                    <input type="checkbox" v-model="options.expandNotes" />
                    Expand all notes
                </label>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from "vue";
    import Datepicker from 'vuejs-datepicker';

    Vue.component("datepicker", Datepicker);

    export default {
        data: function () {
            return {
                options: this.$store.state.searchFilter
            };
        },
        methods: {
            changed() {
                this.$emit('change');
            }
        },
        computed: {
            isTypeable() {
                // there is a bug in Safari with the datepicker
                // https://stackoverflow.com/a/23522755/2616170
                !/^((?!chrome|android).)*safari/i.test(navigator.userAgent);
            }
        }
    };
</script>